export enum AdminPossibleSettings {
  MAINTENANCE = 'MAINTENANCE',
  SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER = 'SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER',
  SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER = 'SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER',
  SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER = 'SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER',
  REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL = 'REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL',
}

export enum AdminPossibleSettingsActions {
  MAINTENANCE_ON = 'MAINTENANCE_ON',
  MAINTENANCE_OFF = 'MAINTENANCE_OFF',
  SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER_ON = 'SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER_ON',
  SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER_OFF = 'SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER_OFF',
  REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL_ON = 'REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL_ON',
  REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL_OFF = 'REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL_OFF',
  SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER_ON = 'SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER_ON',
  SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER_OFF = 'SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER_OFF',
  SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER_ON = 'SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER_ON',
  SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER_OFF = 'SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER_OFF',
}

type AdminLabels = {
  [key in AdminPossibleSettingsActions]: {
    confirmationTitle: string;
    confirmation: string;
  }
};

type OptionTitle = {
  [key in AdminPossibleSettings]: string;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OptionTitle: OptionTitle = {
  MAINTENANCE: 'Maintenance-mode',
  SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER: 'Redirect Magnum to TAF-MRA',
  SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER: 'Redirect Reflex to TAF-MRA',
  SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER: 'Redirect Aura to TAF-MRA',
  REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL: 'Redirect to the old DGHV-portal',
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
const AdminLabels: AdminLabels = {
  [AdminPossibleSettingsActions.MAINTENANCE_ON]: {
    confirmationTitle: 'Enter maintenance-mode',
    confirmation: 'Are you sure you want to put the website in maintenance-mode?',
  },
  [AdminPossibleSettingsActions.MAINTENANCE_OFF]: {
    confirmationTitle: 'Leave maintenance-mode',
    confirmation: 'Are you sure you want to leave the website in maintenance-mode?',
  },
  [AdminPossibleSettingsActions.SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER_ON]: {
    confirmationTitle: 'Redirect Magnum to TAF-MRA',
    confirmation: 'Are you sure you want to redirect all health declarations from Magnum underwriting to TAF-MRA?',
  },
  [AdminPossibleSettingsActions.SWITCH_FROM_IPT_MAGNUM_UNDERWRITER_TO_TAF_UNDERWRITER_OFF]: {
    confirmationTitle: 'Stop redirecting Magnum to TAF-MRA',
    confirmation: 'Are you sure you want to stop redirecting all health declarations from Magnum underwriting to TAF-MRA?',
  },
  [AdminPossibleSettingsActions.REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL_ON]: {
    confirmationTitle: 'Redirect to the old DGHV-portal',
    confirmation: 'Are you sure you want to redirect all health declarations to the old DGHV-portal?',
  },
  [AdminPossibleSettingsActions.REDIRECT_HEALTH_DECLARATIONS_TO_OLD_PORTAL_OFF]: {
    confirmationTitle: 'Stop redirecting to the old DGHV-portal',
    confirmation: 'Are you sure you want to stop redirecting all health declarations to the old DGHV-portal?',
  },
  [AdminPossibleSettingsActions.SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER_ON]: {
    confirmationTitle: 'Redirect Reflex to TAF-MRA',
    confirmation: 'Are you sure you want to redirect all health declarations from Reflex underwriting to TAF-MRA?',
  },
  [AdminPossibleSettingsActions.SWITCH_FROM_QL_REFLEX_UNDERWRITER_TO_TAF_UNDERWRITER_OFF]: {
    confirmationTitle: 'Stop redirecting Reflex to TAF-MRA',
    confirmation: 'Are you sure you want to stop redirecting all health declarations from Reflex underwriting to TAF-MRA?',
  },
  [AdminPossibleSettingsActions.SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER_ON]: {
    confirmationTitle: 'Redirect Aura to TAF-MRA',
    confirmation: 'Are you sure you want to redirect all health declarations from Aura underwriting to TAF-MRA?',
  },
  [AdminPossibleSettingsActions.SWITCH_FROM_ZEL_AURA_UNDERWRITER_TO_TAF_UNDERWRITER_OFF]: {
    confirmationTitle: 'Stop redirecting Aura to TAF-MRA',
    confirmation: 'Are you sure you want to stop redirecting all health declarations from Aura underwriting to TAF-MRA?',
  },
};

export default AdminLabels;
